import { HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import { Dimensions } from 'react-native';

export const rowHeight = 78;

export const columnWidthsTablet = {
  icon: 5,
  sendId: 11,
  monthCompetence: 12,
  type: 8,
  billedCustomers: 10,
  sendDate: 15,
  total: 15,
  status: 19,
  actions: 5,
};

export const columnWidthsDesktop = {
  icon: 4,
  sendId: 10,
  monthCompetence: 15,
  type: 8,
  billedCustomers: 12,
  sendDate: 12,
  total: 10,
  status: 13,
  actions: 15,
};

export const maxHeight = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.5
}px`;

export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.35
}px`;

export const loadingCard = (
  <VStack
    marginBottom={Spacing['inset.xs']}
    borderRadius={Spacing['inline.nano']}
    width={'100%'}
    justifyContent={'space-between'}
    paddingX={Spacing['inset.sm']}
    paddingY={Spacing['inset.nano']}
    background={Color['neutral.white']}>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton
        borderRadius={Spacing['inline.nano']}
        height={'24px'}
        width={'33%'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'24px'} width={'33%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton
        borderRadius={Spacing['inline.nano']}
        height={'18px'}
        width={'29%'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'33%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton
        borderRadius={Spacing['inline.nano']}
        height={'18px'}
        width={'30%'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'33%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton
        borderRadius={Spacing['inline.nano']}
        height={'18px'}
        width={'33%'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'33%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton
        borderRadius={Spacing['inline.nano']}
        height={'18px'}
        width={'33%'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'33%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <VStack width={'30%'}>
        <Skeleton
          borderRadius={Spacing['inline.nano']}
          height={'18px'}
          marginBottom={Spacing['inset.nano']}
        />
        <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} />
      </VStack>
      <Skeleton borderRadius={Spacing['inline.sm']} height={'38px'} width={'33%'} />
    </HStack>
  </VStack>
);
